import { BusinessType } from '@harvestiq/iiq-common';

export type SignatureFormatterArgs = {
  companyName: string;
  userName: string;
};

export type SignatureFormatter = (data: SignatureFormatterArgs) => string;

const commonSignatureFormatter = (data: SignatureFormatterArgs, suffix = '') =>
  `${data.companyName} by ${data.userName}${suffix}`;

export const signatureFormatters: Record<BusinessType, SignatureFormatter> = {
  [BusinessType.BureauOfIndianAffairsAndIndianTribeTreaties]: (data) =>
    commonSignatureFormatter(data, ', Trustee'),

  [BusinessType.Corporation]: (data) => commonSignatureFormatter(data),

  [BusinessType.Estates]: (data) =>
    commonSignatureFormatter(data, ', Executor'),

  [BusinessType.IndividualOperatingAsABusiness]: (data) =>
    commonSignatureFormatter(data, ', Sole Owner'),

  [BusinessType.JointOperations]: (data) => data.userName,

  [BusinessType.LandlordTenant]: (data) => data.userName,

  [BusinessType.LimitedLiabilityCompany]: (data) =>
    commonSignatureFormatter(data),

  [BusinessType.NonProfitOrganizations]: (data) =>
    commonSignatureFormatter(data),

  [BusinessType.Partnership]: (data) =>
    `${data.companyName}, A Partnership, by ${data.userName}, A Partner`,

  [BusinessType.PublicSchools]: (data) => commonSignatureFormatter(data),

  [BusinessType.ReceiverOrLiquidator]: (data) =>
    commonSignatureFormatter(data, ', Receiver'),

  [BusinessType.StateLocalGovernment]: (data) => commonSignatureFormatter(data),

  [BusinessType.TrustRevocable]: (data) =>
    commonSignatureFormatter(data, ', Trustee'),

  [BusinessType.TrustIrrevocable]: (data) =>
    commonSignatureFormatter(data, ', Trustee'),

  [BusinessType.TransferOfRightToIndemnity]: (data) =>
    commonSignatureFormatter(data),
};
